<div
	class="p-8 flex flex-col w-full h-full bg-grey-lightest"
	*ngIf="vm$ | async as vm"
>
	<div class="flex gap-2">
		<h1 class="h1">Transfer</h1>
		<app-anchor
			[url]="teraviewLink"
			[cssClasses]="['!no-underline']"
			[external]="true"
		>
			<ui-button
				data-intercom-target="launch-teraview-button"
				icon="rocket"
				[preset]="BUTTON_PRESETS.MEDIUM_EMPHASIS"
				label="Launch Teraview"
			></ui-button>
		</app-anchor>
	</div>
	<div class="gap-6 flex flex-col">
		<atomic-button-group
			class="top-0"
			type="tab"
			[options]="tabs"
			[(ngModel)]="vm.selectedTab"
		></atomic-button-group>
		<ng-container [ngSwitch]="vm.selectedTab">
			<div *ngSwitchCase="TransferPageTab.XML">
				<div class="flex gap-6">
					<ui-section [title]="firstSectionTitle_()">
						<div section-content class="flex flex-col gap-6">
							<p class="p-sm">
								Review details for your Transfer XML below to confirm accuracy
								before importing into Teraview.
							</p>
							<ui-button
								data-intercom-target="review-xml-details-button"
								icon="edit-circle"
								label="Review XML Details"
								(click)="openXMLDetails()"
							></ui-button>
							<ui-note
								title="Save Time Preparing Documents"
								[callToActionType]="CallToActionType.CLOSE"
								[type]="NoteTypes.CUSTOM"
								[icon]="'info-square-rounded'"
								[iconClasses]="'text-gray-500'"
								closableId="transfer-save-time"
								class="mt-6"
							>
								<p class="p-sm">
									Closer has an Acknowledgement and Direction re Transfer
									(Detailed) that includes the details of your transfer directly
									in the document. Save time by preparing all your documents in
									Closer.
								</p>
								<ui-anchor (click)="handleViewNowBtnClick()"
									>View Now ></ui-anchor
								>
							</ui-note>
						</div>
					</ui-section>
					<ui-section [title]="secondSectionTitle_()">
						<div section-content class="flex flex-col gap-6">
							<p class="p-sm">
								How would you like to import Transfer XML to Teraview? Select
								your preferred method below.
							</p>
							<ng-container *ngFor="let missingField of vm.missingFields">
								<div
									class="flex justify-between self-center bg-orange-lightest w-full p-4 text-sm"
								>
									<div class="flex gap-4">
										<app-icon
											class="text-orange"
											[icon]="ICON.WARNING"
										></app-icon>
										{{ missingField.message }}
									</div>
									<button
										class="text-green w-fit cursor-pointer hover:underline"
										(click)="missingField.action()"
									>
										Add
									</button>
								</div>
							</ng-container>
							<div class="flex gap-2 items-center">
								<ui-button
									icon="copy-plus"
									label="Copy XML URL"
									[preset]="BUTTON_PRESETS.MEDIUM_EMPHASIS"
									(click)="copyXMLToClipboard()"
									[disabled]="!vm.canImportChargeXml"
									[matTooltip]="
										!vm.canImportChargeXml
											? 'Missing fields must be entered before exporting your XML file'
											: ''
									"
								></ui-button>
								<div class="text-xs text-gray items-center">
									(suggested)
									<i-tabler
										name="info-circle"
										class="w-4 h-4"
										[matTooltip]="
											'Save time searching through your downloads! Use the copy XML link to quickly import the XML into Teraview.'
										"
										matTooltipClass="text-left"
									></i-tabler>
								</div>
							</div>
							<div>
								<ui-button
									icon="download"
									label="Download XML"
									[preset]="BUTTON_PRESETS.MEDIUM_EMPHASIS"
									(click)="download()"
									[disabled]="!vm.canImportChargeXml"
									[matTooltip]="
										!vm.canImportChargeXml
											? 'Missing fields must be entered before exporting your XML file'
											: ''
									"
								></ui-button>
							</div>
							<p class="p-sm flex items-center gap-1">
								<ui-anchor
									[icon]="false"
									target="_blank"
									href="https://intercom.help/lawlabs/en/articles/10128437-how-to-export-your-transfer-to-teraview"
									>Learn more</ui-anchor
								>
								about importing the XML into Teraview.
							</p>
						</div>
					</ui-section>
				</div>
			</div>
			<div
				*ngSwitchCase="TransferPageTab.REGISTRATION"
				class="flex flex-col gap-6"
			>
				<app-ai-scraping-notification />
				<div class="flex gap-6">
					<ui-section
						title="Add Registration Details"
						data-intercom-target="transfer-add-registration-details-section"
					>
						<div section-content class="flex flex-col gap-6">
							<p class="p-sm">
								Add the Registered Transfer details from Teraview into your
								matter below.
							</p>
							<div>
								<div
									class="flex items-center justify-between"
									[ngClass]="{
										'pb-2 px-0': eregFile$ | async,
										'px-6': !(eregFile$ | async),
									}"
								>
									<label class="text-sm"
										>Registered Transfer (From Teraview)</label
									>
									<app-ai-document-toggle
										[matterId]="matterId"
										[matterDocumentTypes]="[MatterDocumentType.EREG_TRANSFER]"
										[isChecked]="
											runMatterDocumentAiScrapings()?.[
												MatterDocumentType.EREG_TRANSFER
											]
										"
									/>
								</div>
								<app-sale-file-upload
									*ngIf="!(eregFile$ | async)"
									type="dropzone"
									class="justify-self-center self-center w-full"
									[saleId]="matterId"
									(success)="onEregTransferFileUploadSuccess()"
									[documentName]="'E-Registration Transfer'"
									[documentType]="MatterDocumentType.EREG_TRANSFER"
								></app-sale-file-upload>
								<app-matter-file-card
									*ngIf="eregFile$ | async as eregFile"
									[matterFile]="eregFile"
									(onClick)="viewFile(eregFile)"
								/>
							</div>
							<app-input
								label="Registration Number"
								[labelIcon]="AI_ICON"
								[labelToolTip]="
									(fieldMappings$ | async)?.ereg?.transfer?.registrationNumber
										? AI_TOOLTIP
										: ''
								"
								[labelIconClasses]="AI_ICON_CLASSES"
								[ngModel]="vm.transferDetails?.registrationNumber"
								(debounce)="onRegistrationNumberChange($event)"
							/>
							<app-date-picker
								label="Registration Date"
								[labelIcon]="AI_ICON"
								[labelToolTip]="
									(fieldMappings$ | async)?.ereg?.transfer?.registrationDate
										? AI_TOOLTIP
										: ''
								"
								[labelIconClasses]="AI_ICON_CLASSES"
								[ngModel]="vm.transferDetails?.registrationDate"
								(ngModelChange)="onRegistrationDateChange($event)"
							/>
						</div>
					</ui-section>
					<ui-section
						title="Add Optional Documents"
						data-intercom-target="transfer-add-optional-documents-section"
					>
						<div section-content class="flex flex-col gap-6">
							<p class="p-sm">
								Add additional registrations that relate to this matter.
							</p>
							<ng-container
								*ngFor="
									let register of vm.transferDetails?.additionalRegisters
										| keyvalue;
									trackBy: trackByFn
								"
							>
								<div>
									<ui-anchor
										icon="minus"
										(click)="removeAdditionalRegister(register.key)"
										>Remove Additional Registration</ui-anchor
									>
									<div class="flex flex-col pt-2 gap-6 w-full">
										<div>
											<div
												class="flex items-center justify-between"
												[ngClass]="{
													'pb-2 px-0': vm.files[register.key],
													'px-6': !vm.files[register.key],
												}"
											>
												<label class="text-sm"
													>Additional Registration (From Teraview)</label
												>
												<app-ai-document-toggle
													[matterId]="matterId"
													[matterDocumentTypes]="[
														MatterDocumentType.ADDITIONAL_REGISTER,
													]"
													[isChecked]="
														runMatterDocumentAiScrapings()?.[
															MatterDocumentType.ADDITIONAL_REGISTER
														]
													"
												/>
											</div>

											<app-matter-file-card
												*ngIf="
													vm.files[register.key] as latestFile;
													else noAdditionalRegisterFile
												"
												[matterFile]="latestFile"
												(onClick)="viewFile(latestFile)"
											/>

											<ng-template #noAdditionalRegisterFile>
												<app-sale-file-upload
													type="dropzone"
													class="justify-self-center self-center w-full"
													[saleId]="matterId"
													[documentName]="'Additional Register'"
													[documentType]="
														MatterDocumentType.ADDITIONAL_REGISTER
													"
													[systemTags]="[vm.systemTagPrefix + register.key]"
												></app-sale-file-upload>
											</ng-template>
										</div>
										<app-input
											label="Instrument Name"
											[labelIcon]="AI_ICON"
											[labelToolTip]="
												vm.files[register.key]?.additionalRegisterMappings?.name
													? AI_TOOLTIP
													: ''
											"
											[labelIconClasses]="AI_ICON_CLASSES"
											[ngModel]="register.value?.name"
											(debounce)="
												updateAdditionalRegisterName($event, register.key)
											"
										></app-input>
										<app-input
											label="Registration Number"
											[labelIcon]="AI_ICON"
											[labelToolTip]="
												vm.files[register.key]?.additionalRegisterMappings
													?.registrationNumber
													? AI_TOOLTIP
													: ''
											"
											[labelIconClasses]="AI_ICON_CLASSES"
											[ngModel]="register.value?.registrationNumber"
											(debounce)="
												updateAdditionalRegisterRegistrationNumber(
													$event,
													register.key
												)
											"
										></app-input>
										<app-date-picker
											label="Registration Date"
											[labelIcon]="AI_ICON"
											[labelToolTip]="
												vm.files[register.key]?.additionalRegisterMappings
													?.registrationDate
													? AI_TOOLTIP
													: ''
											"
											[labelIconClasses]="AI_ICON_CLASSES"
											[ngModel]="register.value?.registrationDate"
											(ngModelChange)="
												updateAdditionalRegisterRegistrationDate(
													$event,
													register.key
												)
											"
										></app-date-picker>
									</div>
								</div>
							</ng-container>

							<ui-anchor
								icon="plus"
								(click)="addAdditionalRegister()"
								*ngIf="
									!vm.transferDetails?.additionalRegisters ||
									(vm.transferDetails?.additionalRegisters | keyvalue)
										?.length <= 2
								"
							>
								Add Additional Registration</ui-anchor
							>
						</div>
					</ui-section>
				</div>
			</div>
		</ng-container>
	</div>
</div>
